var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCreditCard = function SvgIconCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.53839C0 2.07936 0.182348 1.63913 0.506931 1.31455C0.831513 0.989965 1.27174 0.807617 1.73077 0.807617H12.1154C12.5744 0.807617 13.0146 0.989965 13.3392 1.31455C13.6638 1.63913 13.8462 2.07936 13.8462 2.53839V6.86531H0V2.53839ZM9.95192 3.40377C9.83717 3.40377 9.72711 3.44936 9.64596 3.5305C9.56482 3.61165 9.51923 3.72171 9.51923 3.83646V4.70185C9.51923 4.81661 9.56482 4.92666 9.64596 5.00781C9.72711 5.08895 9.83717 5.13454 9.95192 5.13454H11.6827C11.7975 5.13454 11.9075 5.08895 11.9887 5.00781C12.0698 4.92666 12.1154 4.81661 12.1154 4.70185V3.83646C12.1154 3.72171 12.0698 3.61165 11.9887 3.5305C11.9075 3.44936 11.7975 3.40377 11.6827 3.40377H9.95192ZM0 8.59608V9.46146C0 9.92049 0.182348 10.3607 0.506931 10.6853C0.831513 11.0099 1.27174 11.1922 1.73077 11.1922H12.1154C12.5744 11.1922 13.0146 11.0099 13.3392 10.6853C13.6638 10.3607 13.8462 9.92049 13.8462 9.46146V8.59608H0Z",
    fill: "#000A4E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-credit-card.f4293d8b.svg";
export { ForwardRef as ReactComponent };